import { ICorrespondenceViewModel } from 'viewModels';
import { AttachmentType, CorrespondenceType, UserProfileType } from '../../../types/enums';

export const correspondenceMock: ICorrespondenceViewModel[] = [
  {
    id: '11111111-1111-1111-1111-111111111133',
    name: 'Diligência na procuradoria ou delegacia',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER],
    attachmentTypes: [AttachmentType.PREPOSITION_LETTER, AttachmentType.PROOF],
    disabled: false,
  },
  {
    id: '11111111-1111-1111-1111-111111111134',
    name: 'Licitação',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER],
    attachmentTypes: [AttachmentType.CONTRACT],
    disabled: false,
  },
  {
    id: 'a6e055b3-61d9-4865-a209-af302f6eee10',
    name: 'Acautelamento de Documento',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: '139e66ae-eb8d-4ae1-803d-693b8ef0b17b',
    name: 'Cópia integral',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: 'c45b62f1-0629-4fed-b45d-2de00bf46e7c',
    name: 'Cópia parcial',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: '17378fac-cdba-43d7-9066-d739e602e034',
    name: 'Despacho com juiz',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: '8720444a-c797-48b3-9005-bf4484201207',
    name: 'Impulsionamento de processo',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: '1c2f212d-32b3-446d-8e8e-121f9177524f',
    name: 'Liberação Processo em Segredo de Justiça',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: '05189dc3-cfb0-4540-8051-8921925d025d',
    name: 'Retirada de alvará',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: '327e6e45-68cb-4047-9c47-f18b71827603',
    name: 'Retirada de Certidão',
    type: CorrespondenceType.DILIGENCE,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
  {
    id: 'ea020fd8-e494-47c6-b74a-d5edf7cc10b0',
    name: 'Protocolo de petição',
    type: CorrespondenceType.PROTOCOL,
    profileTypes: [UserProfileType.LAWYER, UserProfileType.TRAINEE],
    attachmentTypes: [
      AttachmentType.OTHER,
      AttachmentType.DELEGATION,
      AttachmentType.PROTOCOL,
      AttachmentType.AUTHORIZATION,
      AttachmentType.PETITION,
      AttachmentType.PREPOSITION_LETTER,
      AttachmentType.CONTESTATION,
      AttachmentType.DEFENSE,
      AttachmentType.GUIDE,
      AttachmentType.PROOF,
      AttachmentType.CONTRACT,
      AttachmentType.DELEGATION_OR_AUTHORIZATION,
    ],
    disabled: false,
  },
];
